export default "__VITE_ASSET__Da_j3i6G__"